import httpQueue from '../../base/http-queue';
import Config from '@/config';

export async function getToken() {
  const url = `${Config.BFF_SERVICE.URL}/hainan-bff/zodiac/auth`;
  const res = await httpQueue.get<BFFResponse<any>>(url, {}, {});
  return res.data.jwt;
}

export async function getFullToken() {
  const token = await getToken();
  return `Bearer ${token}`;
}
